module.exports = __webpack_public_path__ + "img/family.3c7dfa8b.svg";